import { styled } from '@mui/material/styles'
import AccordionSummary from '@mui/material/AccordionSummary'
import Checkbox from '@mui/material/Checkbox'

export const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  display: 'flex',
  alignItems: 'center',
  margin: 0,
  borderBottom: '1px solid var(--line-200)',
  paddingRight: 4,
  '& .MuiIconButton-edgeEnd': {
    marginRight: 0,
  },
  '&.Mui-expanded': {
    margin: '0px !important',
    minHeight: '48px !important',
  },
}))

export const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.primary.main,
}))
